import React, { useEffect } from "react";
import Commentary from "./Commentary";
import OthersCommentary from "./OthersCommentary";
import { connect } from "react-redux";
import loading from "../loading.gif";
import { getChapter } from "../Actions";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";

function BibleChapter(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
    props.getChapter(props.outerElement.apibook, `${props.chapterNumber}`);
  }, [props.outerElement.apibook, props.chapterNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  const prevChapter = props.chapterNumber - 1;
  const nextChapter = props.chapterNumber + 1;

  const classes = "bible-chapter-button autowidth";

  return (
    <div>
      <br />
      <br />
      <br />
      <h2>
        {props.outerElement.book} {props.chapterNumber}
      </h2>
      {props.loading ? <img src={loading} alt="Loading" /> : null}
      <div
        className="bible-text"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.chapter) }}
      />
      <div>{props.error}</div>

      {prevChapter === 0 ? null : (
        <Link
          className="link"
          to={`/${props.outerElement.apibook}${prevChapter}`}
        >
          <button className={classes}>
            <h5>
              {props.outerElement.book} {prevChapter}
            </h5>
          </button>
        </Link>
      )}

      {!(nextChapter - 1 in props.outerElement.chapters) ? null : (
        <Link
          className="link"
          to={`/${props.outerElement.apibook}${nextChapter}`}
        >
          <button className={classes}>
            <h5>
              {props.outerElement.book} {nextChapter}
            </h5>
          </button>
        </Link>
      )}

      <div style={{textAlign: 'center', marginTop: '20px'}}>
        <Link to="/read">
          <button className="login-button">Back to Readings</button>
        </Link>
      </div>

      {props.loggedIn ? (
        <>
          <Commentary
            book={props.outerElement.book}
            chapter={props.chapterNumber}
            apibook={props.outerElement.apibook}
          />
          <OthersCommentary
            book={props.outerElement.book}
            chapter={props.chapterNumber}
            apibook={props.outerElement.apibook}
          />
        </>
      ) : (
        <Link to="/login">
          <div style={{marginLeft: '20px', marginRight: '20px'}}><button className="login-button">
            Login to Post Commentary or See Others' Commentary
          </button></div>
        </Link>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    chapter: state.chapter,
    loading: state.loading,
    error: state.error,
    loggedIn: state.loggedIn,
  };
};

export default connect(mapStateToProps, { getChapter })(BibleChapter);